export class FailedToGetReportError {

};
